<template>
	<div class="comments">
        <form class="comment-form" >
            <input type="hidden" name="_token" :value="token">
            <div class="row psevdonim-row">
                <img class="avatar" src="/images/blog/avatar.png" alt="slika avatarja">
                <input class="psevdonim" type="text" name="psevdonim" placeholder="Psevdonim" aria-required="true" v-model="postData.psevdonim">
            </div>
            <div class="row comment-row">
                <textarea class="komentar-input" type="text" name="komentar" placeholder="Tvoj Komentar" aria-required="true" v-model="postData.komentar"></textarea>
            </div>
            <div class="row submit-row">
                <div class="pink-btn-container">
                    <button target="_blank" class="izzi-button pink" @click.prevent="objaviKomentar">Objavi komentar</button>
                    <div class="warning" v-cloak>{{ warning }}</div>
                    <div class="info" v-cloak>{{ info ? "Komentar je bil uspešno oddan." : "" }}</div>
                </div>
            </div>
        </form>
        <hr>
        <button class="toggle-comments-btn" @click="toggleComments" v-cloak>{{ areCommentsVisible ? "Skrij komentarje" : "Prikaži komentarje (" + commentsLength + ")" }}</button>
        <div :class="areCommentsVisible ? 'comments-list' : 'comments-list collapsed'" >
            <div class="row comments-list-row" v-for="comment in comments" :key="comment.id">
                <img class="avatar" src="/images/blog/avatar.png" alt="slika avatarja">
                <div class="comment">
                    <h5 v-cloak>{{ comment.psevdonim }}</h5>
                    <div class="text" v-cloak>{{ comment.komentar }}</div>
                </div>
            </div>
        </div>
	</div>
</template>

<script>

export default {
    props: ["blog", "token"],
    data() {
        return {
            comments: undefined,
            postData: {
                komentar: undefined,
                psevdonim: undefined,
                blog_title: this.blog ? this.blog.title : undefined,
                visibility: this.blog ? this.blog.visibility : undefined
            },
            areCommentsVisible: false,
            warning: undefined,
            info: false
        }
	},
    mounted() {
        this.loadComments();
    },
    methods: {
        loadComments() {
            this.blog && axios.get(this.route('blog.get-comments', this.blog.permalink))
                .then(({data}) => {
                    if (!data) {
                        return console.log("ni podatkov");
                    }
                    this.comments = data.comments.filter(item => item.allowed === 1);
            })
            .catch(error => {
                this.warning = true;
                setTimeout(() => {
                    this.warning = false;
                }, 2000);

            });
        },
        toggleComments() {
            this.areCommentsVisible = !this.areCommentsVisible;
        },
        objaviKomentar(e) {
            if (!this.postData.komentar || !this.postData.psevdonim) {
                setTimeout(() => {
                    this.warning = "";
                }, 2000);
                return this.warning = "Izpolniti je treba polje psevdonim in komentar.";
            }
            this.blog && axios.post(this.route('blog.create-comments', this.blog.permalink), this.postData)
                .then(({data}) => {
                    if (!data) {
                        return console.log("ni podatkov");
                    }
                    this.comments = data.comments.filter(item => item.allowed === 1);;
                    this.info = true;
                    setTimeout(() => {
                        this.info = false;
                        this.postData = {
                            komentar: undefined,
                            psevdonim: undefined
                        };
                    }, 2000);
            })
            .catch(error => {
                    this.warning = "Prišlo je do neznane napake. Prosim poskusite kasneje.";
                setTimeout(() => {
                    this.warning = "";
                }, 2000);

            });
        }
    },
    computed: {
        commentsLength() {
            return this.comments ? this.comments.length : 0;
        }
    }
};
</script>
